/** Baxter's "waiting for the model" indicator: word list + steppers. AB#645. */

export const WORDS = [
  'Jumping',
  'Thinking',
  'Cooking',
  'Working',
  'Tinkering',
  'Smithing',
  'Simmering',
  'Running',
  'Swimming',
  'Resting',
] as const;

/** Pick any other word with equal probability, without an immediate repeat. */
export function nextIndex(i: number): number {
  return (i + 1 + Math.floor(Math.random() * (WORDS.length - 1))) % WORDS.length;
}

/** 1, 2, 3, 1, 2, 3 … dots for tick `n`. */
export function dots(n: number): string {
  return '.'.repeat((n % 3) + 1);
}
